module.exports = __webpack_public_path__ + "img/Ativo 2-8 rubens.acc76d3d.png";